module.exports = __webpack_public_path__ + "images/tips/power-ups-1@2x.283ff0f7ee60508a0ea9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/power-ups-1@2x.png
// module id = 9DUj
// module chunks = 13